// extracted by mini-css-extract-plugin
export default {"question":"SurveyEditor_question__Pgx5w","sectionsContainer":"SurveyEditor_sectionsContainer__OHxeL"};